import { ActionTypes } from './constants';
import { AnalyticsTypes } from '../../middleware/google-analytics';
import * as TrackingConstants from '../../EventTrackingConstants';
import { GenderFilterEnum } from '../constants';

export const trackSearchRequestId = searchRequestId => ({
    type: ActionTypes.TRACK_SEARCH_REQUEST,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Loaded Search',
            data: {
                Component: TrackingConstants.TARGETS.SEARCH_RESULTS,
                EventDetails: {
                    searchRequestId,
                },
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.VIEW,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

export const trackDoctorCardClick = (clickLocation, searchResultId) => ({
    type: ActionTypes.TRACK_DOCTOR_CARD_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Doctor Card',
            data: {
                Component: TrackingConstants.TARGETS.INFO,
                Element: clickLocation,
                EventDetails: {
                    searchResultId,
                },
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS_CARD,
            },
        },
    },
});

// only additional criteria currently rendered is showProvidersWhoSeeChildren
export const trackFilterClickAdditionalCriteria = label => ({
    type: ActionTypes.TRACK_FILTER_ADDITIONAL_CRITERIA_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Additional Filters Dropdown',
            label,
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.ADDITIONAL_CRITERIA_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackFilterClickLanguage = label => ({
    type: ActionTypes.TRACK_FILTER_LANGUAGE_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Languages Dropdown',
            label,
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.LANGUAGE_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackFilterClickSortMatches = label => ({
    type: ActionTypes.TRACK_FILTER_SORT_MATCHES_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Sort Matches Dropdown',
            label,
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.SORT_MATCHES_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackFilterClickSpecialHours = label => ({
    type: ActionTypes.TRACK_FILTER_SPECIAL_HOURS_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Special Hours Dropdown',
            label,
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.SPECIAL_HOURS_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackFilterClickHospitalAffiliations = () => ({
    type: ActionTypes.TRACK_FILTER_HOSPITAL_AFFILIATIONS_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Facet Hospital Affiliations Dropdown & Apply',
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.HOSPITAL_AFFILIATIONS_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackFilterClickAvailability = () => ({
    type: ActionTypes.TRACK_FILTER_AVAILABILITY_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Facet Availability Dropdown & Apply',
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_DROPDOWN,
                Element: TrackingConstants.TARGETS.AVAILABILITY_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackMapClick = () => ({
    type: ActionTypes.TRACK_MAP_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Map',
            data: {
                Component: TrackingConstants.TARGETS.SEARCH_MAP,
                Element: TrackingConstants.TARGETS.MAP,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

export const trackMobileMapToggleClick = action => ({
    type: ActionTypes.TRACK_MOBILE_MAP_TOGGLE_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action,
            data: {
                Component: TrackingConstants.TARGETS.MOBILE_MAP_TOGGLE,
                Element: TrackingConstants.TARGETS.MOBILE_MAP_TOGGLE,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

// 'Refine Search' action refers to clicking on the mobile PPS field to expand
// the fields; trackPpsFocus is called when the textbox is actually focused
export const trackMobilePpsClick = () => ({
    type: ActionTypes.TRACK_PPS_CLICK,
    meta: {
        type: AnalyticsTypes.TrackEvent,
        action: 'Refine Search',
        data: {
            Component: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH,
            Element: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH_SEARCH_FIELD,
            Initiator: TrackingConstants.EVENT_INITIATORS.USER,
            InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
            Section: TrackingConstants.TARGETS.SEARCH_BAR,
        },
    },
});

export const trackMoreFiltersClick = () => ({
    type: ActionTypes.TRACK_MORE_FILTERS_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click More Filters',
            data: {
                Component: TrackingConstants.TARGETS.MORE_FILTERS_BUTTON,
                Element: TrackingConstants.TARGETS.MORE_FILTERS_BUTTON,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
            },
        },
    },
});

export const trackPaginationNumberClick = ({ pageNumber }) => dispatch =>
    dispatch({
        type: ActionTypes.TRACK_PAGINATION_NUMBER_CLICK,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Click Pagination Number',
                label: pageNumber,
                data: {
                    Component: TrackingConstants.TARGETS.PAGE_NUMBER,
                    Element: TrackingConstants.TARGETS.PAGE_NUMBER_PAGE_NUMBER,
                    EventDetails: { PageNumber: pageNumber },
                    Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                    InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                    Section: TrackingConstants.TARGETS.PAGINATION,
                },
            },
        },
    });

export const trackPpsChange = ({ query }) => dispatch =>
    dispatch({
        type: ActionTypes.TRACK_PPS_CHANGE,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Change Doctor/Practice Name',
                label: query,
                data: {
                    Component: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH,
                    Element: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH_SEARCH_QUERY,
                    EventDetails: { Query: query },
                    Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                    InteractionType: TrackingConstants.INTERACTION_TYPES.TYPE,
                    Section: TrackingConstants.TARGETS.SEARCH_BAR,
                },
            },
        },
    });

export const trackPpsFocus = () => ({
    type: ActionTypes.TRACK_PPS_FOCUS,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click PatientPoweredSearch TextBox',
            data: {
                Component: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH,
                Element: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH_SEARCH_FIELD,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_BAR,
            },
        },
    },
});

export const trackPpsSelect = ({ selection, selectionType }) => dispatch => {
    const eventDetails = {
        Selection: selection,
        SelectionType: selectionType,
    };

    dispatch({
        type: ActionTypes.TRACK_PPS_SELECT,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Select PatientPoweredSearch Option',
                label: eventDetails,
                data: {
                    Component: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH,
                    Element: TrackingConstants.TARGETS.PATIENT_POWERED_SEARCH_SEARCH_AUTOCOMPLETE_TERM,
                    EventDetails: eventDetails,
                    Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                    InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                    Section: TrackingConstants.TARGETS.SEARCH_BAR,
                },
            },
        },
    });
};

export const trackRefineSearchClickGender = label => ({
    type: ActionTypes.TRACK_REFINE_SEARCH_CLICK_GENDER,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Change Gender',
            label: label === GenderFilterEnum.Male ? 'Male' : 'Female',
            data: {
                Component: TrackingConstants.TARGETS.GENDER,
                Element: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_GENDER_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackRefineSearchClickProcedureDropdown = () => ({
    type: ActionTypes.TRACK_REFINE_SEARCH_CLICK_PROCEDURE_DROPDOWN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Procedure Dropdown',
            data: {
                Component: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_VISIT_REASON,
                Element: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_VISIT_REASON_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackRefineSearchSelectProcedure = ({ procedureId }) => dispatch =>
    dispatch({
        type: ActionTypes.TRACK_REFINE_SEARCH_SELECT_PROCEDURE,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Change Procedure',
                label: procedureId,
                data: {
                    Component: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_VISIT_REASON,
                    Element: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_VISIT_REASON_NEW_VISIT_REASON,
                    EventDetails: { ProcedureId: procedureId },
                    Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                    InteractionType: TrackingConstants.INTERACTION_TYPES.SELECT,
                    Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
                },
            },
        },
    });

export const trackRefineSearchClickSpecialtiesDropdown = () => ({
    type: ActionTypes.TRACK_REFINE_SEARCH_CLICK_SPECIALTY_DROPDOWN,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Click Specialty Dropdown',
            data: {
                Component: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_SPECIALTY,
                Element: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_SPECIALTY_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
            },
        },
    },
});

export const trackRefineSearchSelectSpecialty = ({ specialtyId }) => dispatch =>
    dispatch({
        type: ActionTypes.TRACK_REFINE_SEARCH_SELECT_SPECIALTY,
        meta: {
            analytics: {
                type: AnalyticsTypes.TrackEvent,
                action: 'Change Specialty',
                label: specialtyId,
                data: {
                    Component: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_SPECIALTY,
                    Element: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS_SPECIALTY_NEW_SPECIALTY,
                    EventDetails: { SpecialtyId: specialtyId },
                    Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                    InteractionType: TrackingConstants.INTERACTION_TYPES.SELECT,
                    Section: TrackingConstants.TARGETS.REFINE_SEARCH_RESULTS,
                },
            },
        },
    });

export const trackReviewsReadMoreToggle = () => ({
    type: ActionTypes.TRACK_REVIEWS_READ_MORE_TOGGLE,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Toggle Read More/Less',
            data: {
                Component: TrackingConstants.TARGETS.PATIENT_REVIEWS,
                Element: TrackingConstants.TARGETS.SHOW_MORE_REVIEWS,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_RESULTS_CARD,
            },
        },
    },
});

export const trackScrolledToSearchResult = searchResultId => {
    return (dispatch, getState) => {
        // Prevent duplicate scrolledTo events
        const { searchAnalytics } = getState().search;
        if (searchAnalytics[searchResultId] && !searchAnalytics[searchResultId].seen) {
            dispatch({
                type: ActionTypes.TRACK_SEARCH_SCROLLED_TO_RESULT,
                meta: {
                    analytics: {
                        type: AnalyticsTypes.TrackEvent,
                        action: 'Search Result Scrolled Into View',
                        label: searchResultId,
                        data: {
                            Component: TrackingConstants.TARGETS.SEARCH_RESULTS_CARD,
                            Element: TrackingConstants.TARGETS.SEARCH_RESULTS,
                            EventDetails: {
                                SearchResultId: searchResultId,
                            },
                            Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                            InteractionType: TrackingConstants.INTERACTION_TYPES.SCROLL,
                            Section: TrackingConstants.TARGETS.SEARCH_RESULTS,
                        },
                    },
                },
                payload: {
                    searchResultId,
                },
            });
        }
    };
};

export const trackSearch = () => ({
    type: ActionTypes.TRACK_SEARCH,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Performed Search',
            data: {
                Component: TrackingConstants.TARGETS.SEARCH_BUTTON,
                Element: TrackingConstants.TARGETS.SEARCH_BUTTON_SEARCH_SUBMIT_BUTTON,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.SEARCH_BAR,
            },
        },
    },
});

export const trackTimesgridDataLoaded = data => {
    return (dispatch, getState) => {
        const {
            availability,
            searchResultId,
        } = data;
        // Fix small typo issue
        let label = availability;
        if (label && label.substr(label.length - 1) === ';') {
            label = label.slice(0, -1);
        }
        // Do not resend analytics if we've already sent a data load for this
        // search request id
        const { searchAnalytics } = getState().search;
        if (!searchAnalytics[data.searchResultId]) {
            dispatch({
                type: ActionTypes.TRACK_TIMESGRID_DATA_LOADED,
                meta: {
                    analytics: {
                        type: AnalyticsTypes.TrackEvent,
                        action: 'Timesgrid Loaded Data',
                        label,
                        data: {
                            Component: TrackingConstants.TARGETS.TIMESGRID,
                            Element: TrackingConstants.TARGETS.TIMESGRID,
                            Initiator: TrackingConstants.EVENT_INITIATORS.SYSTEM,
                            InteractionType: TrackingConstants.INTERACTION_TYPES.UPDATE,
                            Section: TrackingConstants.TARGETS.SEARCH_RESULTS_CARD,
                        },
                    },
                },
                payload: {
                    searchResultId,
                },
            });
        }
    };
};

export const trackFacetChipClick = facetId => ({
    type: ActionTypes.TRACK_FACET_CHIP_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Tap Facet Chip',
            label: facetId,
            data: {
                EventDetails: { FacetId: facetId },
                Component: TrackingConstants.TARGETS.FACETED_SEARCH,
                Element: TrackingConstants.TARGETS.FACET_CHIP,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.FACETED_SEARCH,
            },
        },
    },
});

export const trackSortingDropdownClick = () => ({
    type: ActionTypes.TRACK_SORTING_DROPDOWN_CLICK,
    meta: {
        analytics: {
            type: AnalyticsTypes.TrackEvent,
            action: 'Tap Sorting Dropdown',
            data: {
                Component: TrackingConstants.TARGETS.FACETED_SEARCH,
                Element: TrackingConstants.TARGETS.SORT_MATCHES_DROPDOWN,
                Initiator: TrackingConstants.EVENT_INITIATORS.USER,
                InteractionType: TrackingConstants.INTERACTION_TYPES.CLICK,
                Section: TrackingConstants.TARGETS.FACETED_SEARCH,
            },
        },
    },
});
